module.exports = __webpack_public_path__ + "montserrat-black-webfont.f825a6cf9370e71b7309.woff";


//////////////////
// WEBPACK FOOTER
// D:/Honda/Trunk/WizdomWebApp/Wizdom-Web-App/src/assets/fonts/montserrat-black-webfont.woff
// module id = ../../../../../src/assets/fonts/montserrat-black-webfont.woff
// module chunks = styles